'use strict';

let routes = function ($stateProvider, baseState) {

    $stateProvider

        .state('' + baseState + '.travels', {
            abstract: true,
            url: "/travels",
            template: require("./inspect.travels.html"),
        })

        .state('' + baseState + '.travels.overview', {
            url: "/overview",
            template: "<travels-overview></travels-overview>",
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.travels.whereabouts', {
            url: "/whereabouts",
            template: require("./inspect.travels.whereabouts.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.travels.trips', {
            url: "/trips",
            template: require("./inspect.travels.trips.html"),
            data: {pageTitle: 'Inspect'}
        })

        .state('' + baseState + '.travels.travel-claims', {
            url: "/travel-claims",
            template: require("./inspect.travels.travel-claims.html"),
            data: {pageTitle: 'Inspect'}
        })

};

let loadRoutesLazily = function ($stateProvider, baseState) {

    let lazyStateProvider = {
        states: [],
        state: function (name, stateConfig) {
            let state = angular.merge({name: name}, stateConfig);
            this.states.push(state);
            return this;
        }
    };
    routes(lazyStateProvider, baseState);
    $stateProvider.state(baseState + '.travels.**', {
        url: "/travels",
        lazyLoad: function ($transition$, ParentService) {
            return lazyStateProvider;
        },
    });

};

export default {
    routes: routes,
    loadRoutesLazily: loadRoutesLazily,
};



// WEBPACK FOOTER //
// .-dna/app/subsections/whereabouts/whereabouts.js